import React from 'react'

export default function TaskProfile() {
  return (
    <div className='main'>TaskProfile</div>
  )
}
